"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OnTick_ClearRoom_WhenEnemiesDefeatedRoomScript = void 0;
const __1 = require("../../..");
const enums_1 = require("../../enums");
const Registries_1 = require("../../state/Registries");
const mkDefaultMeta = () => ({});
let OnTick_ClearRoom_WhenEnemiesDefeatedRoomScript = class OnTick_ClearRoom_WhenEnemiesDefeatedRoomScript {
    run(sequence, container, state, args) {
        var _a;
        if (((_a = container.getRoom(state.id)) === null || _a === void 0 ? void 0 : _a.state) !== "Active") {
            return;
        }
        for (const actor of state.actors) {
            if (container.getFaction(actor) !== enums_1.Faction.Enemy) {
                continue;
            }
            else if (!container.isDeceased(actor)) {
                return;
            }
        }
        container.dispatch(sequence, 0, new __1.ClearRoomActionArgs(state.id));
    }
};
OnTick_ClearRoom_WhenEnemiesDefeatedRoomScript = __decorate([
    Registries_1.RoomScripts.register("OnTick_ClearRoom_WhenEnemiesDefeated")
], OnTick_ClearRoom_WhenEnemiesDefeatedRoomScript);
exports.OnTick_ClearRoom_WhenEnemiesDefeatedRoomScript = OnTick_ClearRoom_WhenEnemiesDefeatedRoomScript;
